import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { resolveImage } from "@/lib/api";

export const BeforeAfter = ({ before, after, alt = "Before and after" }) => (
  <div className="rounded-2xl overflow-hidden card-shadow border border-gray-100" data-testid="before-after-slider">
    <ReactCompareSlider
      itemOne={<ReactCompareSliderImage src={resolveImage(before)} alt={`${alt} - before`} />}
      itemTwo={<ReactCompareSliderImage src={resolveImage(after)} alt={`${alt} - after`} />}
      style={{ height: "100%", width: "100%" }}
    />
  </div>
);
